/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PressReleaseGifAnimation,
    PressReleaseGifAnimationFromJSON,
    PressReleaseGifAnimationFromJSONTyped,
    PressReleaseGifAnimationToJSON,
} from './PressReleaseGifAnimation';
import {
    PressReleaseImage,
    PressReleaseImageFromJSON,
    PressReleaseImageFromJSONTyped,
    PressReleaseImageToJSON,
} from './PressReleaseImage';
import {
    PressReleaseLocation,
    PressReleaseLocationFromJSON,
    PressReleaseLocationFromJSONTyped,
    PressReleaseLocationToJSON,
} from './PressReleaseLocation';

/**
 * プレスリリース自動保存APIのリクエストパラメータ
 * @export
 * @interface PressReleaseAutoSaveRequestParams
 */
export interface PressReleaseAutoSaveRequestParams {
    /**
     * エディタのバージョン @see https://www.notion.so/fea20dce98c94dc792d9d0e965ca50b0
     * @type {string}
     * @memberof PressReleaseAutoSaveRequestParams
     */
    editorVersion?: string | null;
    /**
     * タイトル
     * @type {string}
     * @memberof PressReleaseAutoSaveRequestParams
     */
    title?: string | null;
    /**
     * サブタイトル
     * @type {string}
     * @memberof PressReleaseAutoSaveRequestParams
     */
    subtitle?: string | null;
    /**
     * リード文
     * @type {string}
     * @memberof PressReleaseAutoSaveRequestParams
     */
    head?: string | null;
    /**
     * 本文
     * @type {string}
     * @memberof PressReleaseAutoSaveRequestParams
     */
    text?: string | null;
    /**
     * 追加情報
     * @type {string}
     * @memberof PressReleaseAutoSaveRequestParams
     */
    footer?: string | null;
    /**
     * 関連URL
     * @type {string}
     * @memberof PressReleaseAutoSaveRequestParams
     */
    referenceUrl?: string | null;
    /**
     * メイン画像ファイル名
     * @type {string}
     * @memberof PressReleaseAutoSaveRequestParams
     */
    imageFileNameMain?: string | null;
    /**
     * メイン画像ファイル名(s3)
     * @type {string}
     * @memberof PressReleaseAutoSaveRequestParams
     */
    imageFileNameMainS3?: string | null;
    /**
     * プレスリリース画像
     * @type {Array<PressReleaseImage>}
     * @memberof PressReleaseAutoSaveRequestParams
     */
    images?: Array<PressReleaseImage> | null;
    /**
     * GIFアニメーションリスト
     * @type {Array<PressReleaseGifAnimation>}
     * @memberof PressReleaseAutoSaveRequestParams
     */
    gifAnimations?: Array<PressReleaseGifAnimation> | null;
    /**
     * プレスリリースファイル名(一般公開)
     * @type {string}
     * @memberof PressReleaseAutoSaveRequestParams
     */
    releaseFileName?: string | null;
    /**
     * 参考資料ファイル名(一般公開)
     * @type {string}
     * @memberof PressReleaseAutoSaveRequestParams
     */
    referenceFileName?: string | null;
    /**
     * プレスリリースファイル名(メディア限定)
     * @type {string}
     * @memberof PressReleaseAutoSaveRequestParams
     */
    mediaReleaseFileName?: string | null;
    /**
     * 参考資料ファイル名(メディア限定)
     * @type {string}
     * @memberof PressReleaseAutoSaveRequestParams
     */
    mediaReferenceFileName?: string | null;
    /**
     * 位置情報
     * @type {Array<PressReleaseLocation>}
     * @memberof PressReleaseAutoSaveRequestParams
     */
    locations?: Array<PressReleaseLocation> | null;
    /**
     * 記事ネタタグキーワード
     * @type {Array<string>}
     * @memberof PressReleaseAutoSaveRequestParams
     */
    keywords?: Array<string> | null;
    /**
     * リリース種類
     * @type {string}
     * @memberof PressReleaseAutoSaveRequestParams
     */
    releaseTypeId?: string | null;
    /**
     * ビジネスカテゴリ
     * @type {number}
     * @memberof PressReleaseAutoSaveRequestParams
     */
    busiCateIdMain?: number | null;
    /**
     * サブカテゴリ
     * @type {number}
     * @memberof PressReleaseAutoSaveRequestParams
     */
    busiCateIdSub?: number | null;
    /**
     * メディアリスト選択設定(1:手動選択/2:自動選択)
     * @type {number}
     * @memberof PressReleaseAutoSaveRequestParams
     */
    releaseSendTargetType?: number | null;
    /**
     * メディアリストid
     * @type {number}
     * @memberof PressReleaseAutoSaveRequestParams
     */
    companyReleaseMediaJoinMasterId?: number | null;
    /**
     * メディアリストid(インポート)
     * @type {number}
     * @memberof PressReleaseAutoSaveRequestParams
     */
    companyMMyReleaseMediaMasterId?: number | null;
    /**
     * メディアリストへのメール配信を行う
     * @type {boolean}
     * @memberof PressReleaseAutoSaveRequestParams
     */
    releaseAdditionalHeadlineFlg?: boolean | null;
    /**
     * メディアリストへのFAX配信を行う
     * @type {boolean}
     * @memberof PressReleaseAutoSaveRequestParams
     */
    releaseAdditionalFaxFlg?: boolean | null;
    /**
     * FAX用ファイル名
     * @type {string}
     * @memberof PressReleaseAutoSaveRequestParams
     */
    releaseFaxFileName?: string | null;
    /**
     * メールタイトルにprefix文字列を挿入する [~v3.0.0]
     * @type {boolean}
     * @memberof PressReleaseAutoSaveRequestParams
     */
    mailTitlePrefixFlg?: boolean;
    /**
     * メールタイトルprefix文字列 [~v3.0.0]
     * @type {string}
     * @memberof PressReleaseAutoSaveRequestParams
     */
    mailTitlePrefixText?: string | null;
    /**
     * メールタイトル先頭に企業名(略称)を追加する [^v3.0.0]
     * @type {boolean}
     * @memberof PressReleaseAutoSaveRequestParams
     */
    mailTitlePrefixCompanyNameFlg?: boolean;
    /**
     * メールタイトルを差し替える [^v3.0.0]
     * @type {boolean}
     * @memberof PressReleaseAutoSaveRequestParams
     */
    mailTitleReplacingFlg?: boolean;
    /**
     * メールタイトル [^v3.0.0]
     * @type {string}
     * @memberof PressReleaseAutoSaveRequestParams
     */
    mailTitle?: string | null;
    /**
     * メール本文の先頭に指定した文字列を挿入する
     * @type {boolean}
     * @memberof PressReleaseAutoSaveRequestParams
     */
    mailBodyHeadFlg?: boolean | null;
    /**
     * メール本文先頭に挿入する文字列
     * @type {string}
     * @memberof PressReleaseAutoSaveRequestParams
     */
    mailBodyHeadText?: string | null;
    /**
     * メディアユーザーへ配信する
     * @type {boolean}
     * @memberof PressReleaseAutoSaveRequestParams
     */
    mediaUserSendmailFlg?: boolean | null;
    /**
     * 個人ユーザーへ配信する
     * @type {boolean}
     * @memberof PressReleaseAutoSaveRequestParams
     */
    socialmediaUserSendmailFlg?: boolean | null;
    /**
     * 提携メディアへの転載
     * @type {boolean}
     * @memberof PressReleaseAutoSaveRequestParams
     */
    otherSiteSendFlg?: boolean | null;
    /**
     * メディア限定公開
     * @type {boolean}
     * @memberof PressReleaseAutoSaveRequestParams
     */
    releaseMediaUserOnlyFlg?: boolean | null;
    /**
     * PR TIMESのサイトに公開しない
     * @type {boolean}
     * @memberof PressReleaseAutoSaveRequestParams
     */
    releaseMediaListOnlyFlg?: boolean | null;
    /**
     * 指定したメディアリストにのみ素材ダウンロードを表示する
     * @type {boolean}
     * @memberof PressReleaseAutoSaveRequestParams
     */
    isFileDownloadUnavailable?: boolean | null;
    /**
     * 予約配信日(Y-m-d)
     * @type {string}
     * @memberof PressReleaseAutoSaveRequestParams
     */
    releaseDate?: string | null;
    /**
     * 予約配信時間(Gi) e.g. '0000', '0900', '2300'
     * @type {string}
     * @memberof PressReleaseAutoSaveRequestParams
     */
    releaseTimeKbn2?: string | null;
    /**
     * twitter投稿
     * @type {boolean}
     * @memberof PressReleaseAutoSaveRequestParams
     */
    twitterSendFlg?: boolean | null;
    /**
     * facebook投稿
     * @type {boolean}
     * @memberof PressReleaseAutoSaveRequestParams
     */
    facebookSendFlg?: boolean | null;
    /**
     * プレスリリースの目的ID
     * @type {number}
     * @memberof PressReleaseAutoSaveRequestParams
     */
    purposeId?: number | null;
    /**
     * プレスリリースのテンプレートID
     * @type {number}
     * @memberof PressReleaseAutoSaveRequestParams
     */
    templateId?: number | null;
}

export function PressReleaseAutoSaveRequestParamsFromJSON(json: any): PressReleaseAutoSaveRequestParams {
    return PressReleaseAutoSaveRequestParamsFromJSONTyped(json, false);
}

export function PressReleaseAutoSaveRequestParamsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PressReleaseAutoSaveRequestParams {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'editorVersion': !exists(json, 'editor_version') ? undefined : json['editor_version'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'subtitle': !exists(json, 'subtitle') ? undefined : json['subtitle'],
        'head': !exists(json, 'head') ? undefined : json['head'],
        'text': !exists(json, 'text') ? undefined : json['text'],
        'footer': !exists(json, 'footer') ? undefined : json['footer'],
        'referenceUrl': !exists(json, 'reference_url') ? undefined : json['reference_url'],
        'imageFileNameMain': !exists(json, 'image_file_name_main') ? undefined : json['image_file_name_main'],
        'imageFileNameMainS3': !exists(json, 'image_file_name_main_s3') ? undefined : json['image_file_name_main_s3'],
        'images': !exists(json, 'images') ? undefined : (json['images'] === null ? null : (json['images'] as Array<any>).map(PressReleaseImageFromJSON)),
        'gifAnimations': !exists(json, 'gif_animations') ? undefined : (json['gif_animations'] === null ? null : (json['gif_animations'] as Array<any>).map(PressReleaseGifAnimationFromJSON)),
        'releaseFileName': !exists(json, 'release_file_name') ? undefined : json['release_file_name'],
        'referenceFileName': !exists(json, 'reference_file_name') ? undefined : json['reference_file_name'],
        'mediaReleaseFileName': !exists(json, 'media_release_file_name') ? undefined : json['media_release_file_name'],
        'mediaReferenceFileName': !exists(json, 'media_reference_file_name') ? undefined : json['media_reference_file_name'],
        'locations': !exists(json, 'locations') ? undefined : (json['locations'] === null ? null : (json['locations'] as Array<any>).map(PressReleaseLocationFromJSON)),
        'keywords': !exists(json, 'keywords') ? undefined : json['keywords'],
        'releaseTypeId': !exists(json, 'release_type_id') ? undefined : json['release_type_id'],
        'busiCateIdMain': !exists(json, 'busi_cate_id_main') ? undefined : json['busi_cate_id_main'],
        'busiCateIdSub': !exists(json, 'busi_cate_id_sub') ? undefined : json['busi_cate_id_sub'],
        'releaseSendTargetType': !exists(json, 'release_send_target_type') ? undefined : json['release_send_target_type'],
        'companyReleaseMediaJoinMasterId': !exists(json, 'company_release_media_join_master_id') ? undefined : json['company_release_media_join_master_id'],
        'companyMMyReleaseMediaMasterId': !exists(json, 'company_m_my_release_media_master_id') ? undefined : json['company_m_my_release_media_master_id'],
        'releaseAdditionalHeadlineFlg': !exists(json, 'release_additional_headline_flg') ? undefined : json['release_additional_headline_flg'],
        'releaseAdditionalFaxFlg': !exists(json, 'release_additional_fax_flg') ? undefined : json['release_additional_fax_flg'],
        'releaseFaxFileName': !exists(json, 'release_fax_file_name') ? undefined : json['release_fax_file_name'],
        'mailTitlePrefixFlg': !exists(json, 'mail_title_prefix_flg') ? undefined : json['mail_title_prefix_flg'],
        'mailTitlePrefixText': !exists(json, 'mail_title_prefix_text') ? undefined : json['mail_title_prefix_text'],
        'mailTitlePrefixCompanyNameFlg': !exists(json, 'mail_title_prefix_company_name_flg') ? undefined : json['mail_title_prefix_company_name_flg'],
        'mailTitleReplacingFlg': !exists(json, 'mail_title_replacing_flg') ? undefined : json['mail_title_replacing_flg'],
        'mailTitle': !exists(json, 'mail_title') ? undefined : json['mail_title'],
        'mailBodyHeadFlg': !exists(json, 'mail_body_head_flg') ? undefined : json['mail_body_head_flg'],
        'mailBodyHeadText': !exists(json, 'mail_body_head_text') ? undefined : json['mail_body_head_text'],
        'mediaUserSendmailFlg': !exists(json, 'media_user_sendmail_flg') ? undefined : json['media_user_sendmail_flg'],
        'socialmediaUserSendmailFlg': !exists(json, 'socialmedia_user_sendmail_flg') ? undefined : json['socialmedia_user_sendmail_flg'],
        'otherSiteSendFlg': !exists(json, 'other_site_send_flg') ? undefined : json['other_site_send_flg'],
        'releaseMediaUserOnlyFlg': !exists(json, 'release_media_user_only_flg') ? undefined : json['release_media_user_only_flg'],
        'releaseMediaListOnlyFlg': !exists(json, 'release_media_list_only_flg') ? undefined : json['release_media_list_only_flg'],
        'isFileDownloadUnavailable': !exists(json, 'is_file_download_unavailable') ? undefined : json['is_file_download_unavailable'],
        'releaseDate': !exists(json, 'release_date') ? undefined : json['release_date'],
        'releaseTimeKbn2': !exists(json, 'release_time_kbn_2') ? undefined : json['release_time_kbn_2'],
        'twitterSendFlg': !exists(json, 'twitter_send_flg') ? undefined : json['twitter_send_flg'],
        'facebookSendFlg': !exists(json, 'facebook_send_flg') ? undefined : json['facebook_send_flg'],
        'purposeId': !exists(json, 'purpose_id') ? undefined : json['purpose_id'],
        'templateId': !exists(json, 'template_id') ? undefined : json['template_id'],
    };
}

export function PressReleaseAutoSaveRequestParamsToJSON(value?: PressReleaseAutoSaveRequestParams | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'editor_version': value.editorVersion,
        'title': value.title,
        'subtitle': value.subtitle,
        'head': value.head,
        'text': value.text,
        'footer': value.footer,
        'reference_url': value.referenceUrl,
        'image_file_name_main': value.imageFileNameMain,
        'image_file_name_main_s3': value.imageFileNameMainS3,
        'images': value.images === undefined ? undefined : (value.images === null ? null : (value.images as Array<any>).map(PressReleaseImageToJSON)),
        'gif_animations': value.gifAnimations === undefined ? undefined : (value.gifAnimations === null ? null : (value.gifAnimations as Array<any>).map(PressReleaseGifAnimationToJSON)),
        'release_file_name': value.releaseFileName,
        'reference_file_name': value.referenceFileName,
        'media_release_file_name': value.mediaReleaseFileName,
        'media_reference_file_name': value.mediaReferenceFileName,
        'locations': value.locations === undefined ? undefined : (value.locations === null ? null : (value.locations as Array<any>).map(PressReleaseLocationToJSON)),
        'keywords': value.keywords,
        'release_type_id': value.releaseTypeId,
        'busi_cate_id_main': value.busiCateIdMain,
        'busi_cate_id_sub': value.busiCateIdSub,
        'release_send_target_type': value.releaseSendTargetType,
        'company_release_media_join_master_id': value.companyReleaseMediaJoinMasterId,
        'company_m_my_release_media_master_id': value.companyMMyReleaseMediaMasterId,
        'release_additional_headline_flg': value.releaseAdditionalHeadlineFlg,
        'release_additional_fax_flg': value.releaseAdditionalFaxFlg,
        'release_fax_file_name': value.releaseFaxFileName,
        'mail_title_prefix_flg': value.mailTitlePrefixFlg,
        'mail_title_prefix_text': value.mailTitlePrefixText,
        'mail_title_prefix_company_name_flg': value.mailTitlePrefixCompanyNameFlg,
        'mail_title_replacing_flg': value.mailTitleReplacingFlg,
        'mail_title': value.mailTitle,
        'mail_body_head_flg': value.mailBodyHeadFlg,
        'mail_body_head_text': value.mailBodyHeadText,
        'media_user_sendmail_flg': value.mediaUserSendmailFlg,
        'socialmedia_user_sendmail_flg': value.socialmediaUserSendmailFlg,
        'other_site_send_flg': value.otherSiteSendFlg,
        'release_media_user_only_flg': value.releaseMediaUserOnlyFlg,
        'release_media_list_only_flg': value.releaseMediaListOnlyFlg,
        'is_file_download_unavailable': value.isFileDownloadUnavailable,
        'release_date': value.releaseDate,
        'release_time_kbn_2': value.releaseTimeKbn2,
        'twitter_send_flg': value.twitterSendFlg,
        'facebook_send_flg': value.facebookSendFlg,
        'purpose_id': value.purposeId,
        'template_id': value.templateId,
    };
}

